// extracted by mini-css-extract-plugin
module.exports = {"prevent-resize":"styles-module__prevent-resize___3XwOE"};